import { fromJS } from 'immutable';

import * as actionTypes from './actionTypes';

export const initialState = fromJS({
  brokerageInfo: {},
  marketIdentifier: undefined,
  marketTrends: {},
  profileData: {},
  profileDataError: undefined,
  profileDataIsLoading: true,
});

interface IAction {
  type: string;
  payload?: any;
  error?: boolean;
}

export default function reducer(state = initialState, action: IAction) {
  switch (action.type) {
    case actionTypes.BEGIN_LOADING_PROFILE_DATA:
      return state.merge({
        profileDataError: '',
        profileDataIsLoading: true,
      });
    case actionTypes.RECEIVE_DATA:
      return state.merge({
        brokerageInfo: fromJS(action.payload.brokerageInfo),
        marketIdentifier: fromJS(action.payload.marketIdentifier),
        profileData: fromJS(action.payload.profileData),
        profileDataIsLoading: false,
      });
    case actionTypes.ERROR_PROFILE_DATA:
      return state.merge({
        profileDataError: action.payload.error,
        profileDataIsLoading: false,
      });
    case actionTypes.CLEAR_PROFILE_DATA:
      return state.merge({ profileData: {} });
    case actionTypes.RECEIVE_MARKET_TRENDS:
      return state.merge({
        marketTrends: fromJS(action.payload.marketTrends),
      });
    default:
      return state;
  }
}
